import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  get_entries3nqgftw5r4i02 as get_entries,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
} from '../../models/data.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Spaceoq5xo9lsieqc as Space } from './Space.commonHtml.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Default_getInstance3u4i6y54ri5cn as Default_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import { get_overlayFrameoxw7w6vy469q as get_overlayFrame } from '../l2/AppNavV2.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../ViewWrapper.mjs';
import { get_atTopEnd21ub47e8cwtv6 as get_atTopEnd } from '../helpers.mjs';
import { Button263cw152yl80e as Button } from './Button.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from './Button.mjs';
import {
  popoverWriter15t7cytib9867 as popoverWriter,
  keepPopoverOpen73dsmiswwblk as keepPopoverOpen,
  get_popoverKeepOpenw4wxrp4j0c27 as get_popoverKeepOpen,
  closeSiblingPopovers3h32tmqbne06n as closeSiblingPopovers,
} from '../ViewContextExtensions.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from './ContainingView.commonHtml.mjs';
import { PopoverSemantic_getInstance1gd43d9y00yoy as PopoverSemantic_getInstance } from '../../models/Theme.mjs';
import { maxOf1m19db8qhkqy5 as maxOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_2,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function open$_anonymous_$_anonymous_$reposition_r379wc($this_frame, this$0, tx, ty, txm, tym) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = $this_frame.tb5_1;
  var tmp0_safe_receiver = this_0.vb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver instanceof HTMLElement))
      THROW_CCE();
    var sourcePosition = ensureNotNull(this$0.fc2_1.tb5_1.vb3_1).getBoundingClientRect();
    var screen = ensureNotNull(document.body).getBoundingClientRect();
    var size = tmp0_safe_receiver.getBoundingClientRect();
    tmp0_safe_receiver.style.removeProperty('top');
    tmp0_safe_receiver.style.removeProperty('left');
    tmp0_safe_receiver.style.removeProperty('right');
    tmp0_safe_receiver.style.removeProperty('bottom');
    tmp0_safe_receiver.style.removeProperty('transform');
    var gap = 0;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_1 = ArrayList().w();
    this_1.v(this$0.kc2_1);
    var _iterator__ex2g4s = get_entries().m1();
    while (_iterator__ex2g4s.n1()) {
      var otherAlign = _iterator__ex2g4s.o1();
      this_1.v(this$0.kc2_1.ld5(VOID, VOID, otherAlign));
    }
    var _iterator__ex2g4s_0 = plus(listOf(this$0.kc2_1.jd5_1), get_entries()).m1();
    while (_iterator__ex2g4s_0.n1()) {
      var otherAlign_0 = _iterator__ex2g4s_0.o1();
      this_1.v(this$0.kc2_1.ld5(VOID, !this$0.kc2_1.id5_1, otherAlign_0));
    }
    var altAligns = this$0.kc2_1.id5_1 ? listOf_0([Align_End_getInstance(), Align_Center_getInstance(), Align_Start_getInstance(), Align_Stretch_getInstance()]) : listOf_0([Align_Start_getInstance(), Align_Center_getInstance(), Align_End_getInstance(), Align_Stretch_getInstance()]);
    var _iterator__ex2g4s_1 = altAligns.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var otherAlign_1 = _iterator__ex2g4s_1.o1();
      this_1.v(this$0.kc2_1.kd5(!this$0.kc2_1.hd5_1, !this$0.kc2_1.id5_1, otherAlign_1));
    }
    var tmp0 = this_1.c8();
    var tmp$ret$5;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_2 = tmp0.m1();
      while (_iterator__ex2g4s_2.n1()) {
        var element = _iterator__ex2g4s_2.o1();
        var proposed = open$_anonymous_$_anonymous_$reposition$_anonymous_$bounds_vk1tys(element, sourcePosition, gap, size, screen);
        var epsilon = 0.01;
        if (proposed.left >= screen.left - epsilon && proposed.right <= screen.right + epsilon && proposed.top >= screen.top - epsilon && proposed.bottom <= screen.bottom + epsilon) {
          tmp$ret$5 = element;
          break $l$block;
        }
      }
      tmp$ret$5 = null;
    }
    var currentDirection = tmp$ret$5;
    if (currentDirection == null) {
      this$0.odp();
      tmp0_safe_receiver.style.left = '0px';
      tmp0_safe_receiver.style.right = '0px';
      tmp0_safe_receiver.style.bottom = '0px';
      tmp0_safe_receiver.style.top = '0px';
      tx._v = 0.0;
      ty._v = 0.0;
      txm._v = 0;
      tym._v = 0;
    } else if (currentDirection.hd5_1) {
      if (currentDirection.id5_1) {
        tx._v = sourcePosition.right;
        txm._v = 0;
      } else {
        tx._v = sourcePosition.left;
        txm._v = -100;
      }
      switch (currentDirection.jd5_1.b4_1) {
        case 0:
          ty._v = sourcePosition.bottom;
          tym._v = -100;
          break;
        case 2:
          ty._v = sourcePosition.top;
          tym._v = 0;
          break;
        case 1:
          ty._v = (sourcePosition.top + sourcePosition.bottom) / 2;
          tym._v = -50;
          break;
        case 3:
          ty._v = 0.0;
          tym._v = 0;
          tmp0_safe_receiver.style.top = '0px';
          tmp0_safe_receiver.style.bottom = '0px';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    } else {
      if (currentDirection.id5_1) {
        ty._v = sourcePosition.bottom;
        tym._v = 0;
      } else {
        ty._v = sourcePosition.top;
        tym._v = -100;
      }
      switch (currentDirection.jd5_1.b4_1) {
        case 0:
          tx._v = sourcePosition.right;
          txm._v = -100;
          break;
        case 2:
          tx._v = sourcePosition.left;
          txm._v = 0;
          break;
        case 1:
          tx._v = (sourcePosition.left + sourcePosition.right) / 2;
          txm._v = -50;
          break;
        case 3:
          tx._v = 0.0;
          txm._v = 0;
          tmp0_safe_receiver.style.left = '0px';
          tmp0_safe_receiver.style.right = '0px';
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    tmp0_safe_receiver.style.transform = 'translate(' + tx._v + 'px, ' + ty._v + 'px) translate(' + txm._v + '%, ' + tym._v + '%)';
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.ub3_1.v((it) => {
      if (!(it instanceof HTMLElement))
        THROW_CCE();
      var sourcePosition = ensureNotNull(this$0.fc2_1.tb5_1.vb3_1).getBoundingClientRect();
      var screen = ensureNotNull(document.body).getBoundingClientRect();
      var size = it.getBoundingClientRect();
      it.style.removeProperty('top');
      it.style.removeProperty('left');
      it.style.removeProperty('right');
      it.style.removeProperty('bottom');
      it.style.removeProperty('transform');
      var gap = 0;
      // Inline function 'kotlin.collections.buildList' call
      // Inline function 'kotlin.collections.buildListInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = ArrayList().w();
      this_0.v(this$0.kc2_1);
      var _iterator__ex2g4s = get_entries().m1();
      while (_iterator__ex2g4s.n1()) {
        var otherAlign = _iterator__ex2g4s.o1();
        this_0.v(this$0.kc2_1.ld5(VOID, VOID, otherAlign));
      }
      var _iterator__ex2g4s_0 = plus(listOf(this$0.kc2_1.jd5_1), get_entries()).m1();
      while (_iterator__ex2g4s_0.n1()) {
        var otherAlign_0 = _iterator__ex2g4s_0.o1();
        this_0.v(this$0.kc2_1.ld5(VOID, !this$0.kc2_1.id5_1, otherAlign_0));
      }
      var altAligns = this$0.kc2_1.id5_1 ? listOf_0([Align_End_getInstance(), Align_Center_getInstance(), Align_Start_getInstance(), Align_Stretch_getInstance()]) : listOf_0([Align_Start_getInstance(), Align_Center_getInstance(), Align_End_getInstance(), Align_Stretch_getInstance()]);
      var _iterator__ex2g4s_1 = altAligns.m1();
      while (_iterator__ex2g4s_1.n1()) {
        var otherAlign_1 = _iterator__ex2g4s_1.o1();
        this_0.v(this$0.kc2_1.kd5(!this$0.kc2_1.hd5_1, !this$0.kc2_1.id5_1, otherAlign_1));
      }
      var tmp0 = this_0.c8();
      var tmp$ret$13;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_2 = tmp0.m1();
        while (_iterator__ex2g4s_2.n1()) {
          var element = _iterator__ex2g4s_2.o1();
          var proposed = open$_anonymous_$_anonymous_$reposition$_anonymous_$bounds_vk1tys(element, sourcePosition, gap, size, screen);
          var epsilon = 0.01;
          if (proposed.left >= screen.left - epsilon && proposed.right <= screen.right + epsilon && proposed.top >= screen.top - epsilon && proposed.bottom <= screen.bottom + epsilon) {
            tmp$ret$13 = element;
            break $l$block_0;
          }
        }
        tmp$ret$13 = null;
      }
      var currentDirection = tmp$ret$13;
      if (currentDirection == null) {
        this$0.odp();
        it.style.left = '0px';
        it.style.right = '0px';
        it.style.bottom = '0px';
        it.style.top = '0px';
        tx._v = 0.0;
        ty._v = 0.0;
        txm._v = 0;
        tym._v = 0;
      } else if (currentDirection.hd5_1) {
        if (currentDirection.id5_1) {
          tx._v = sourcePosition.right;
          txm._v = 0;
        } else {
          tx._v = sourcePosition.left;
          txm._v = -100;
        }
        switch (currentDirection.jd5_1.b4_1) {
          case 0:
            ty._v = sourcePosition.bottom;
            tym._v = -100;
            break;
          case 2:
            ty._v = sourcePosition.top;
            tym._v = 0;
            break;
          case 1:
            ty._v = (sourcePosition.top + sourcePosition.bottom) / 2;
            tym._v = -50;
            break;
          case 3:
            ty._v = 0.0;
            tym._v = 0;
            it.style.top = '0px';
            it.style.bottom = '0px';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else {
        if (currentDirection.id5_1) {
          ty._v = sourcePosition.bottom;
          tym._v = 0;
        } else {
          ty._v = sourcePosition.top;
          tym._v = -100;
        }
        switch (currentDirection.jd5_1.b4_1) {
          case 0:
            tx._v = sourcePosition.right;
            txm._v = -100;
            break;
          case 2:
            tx._v = sourcePosition.left;
            txm._v = 0;
            break;
          case 1:
            tx._v = (sourcePosition.left + sourcePosition.right) / 2;
            txm._v = -50;
            break;
          case 3:
            tx._v = 0.0;
            txm._v = 0;
            it.style.left = '0px';
            it.style.right = '0px';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      it.style.transform = 'translate(' + tx._v + 'px, ' + ty._v + 'px) translate(' + txm._v + '%, ' + tym._v + '%)';
      return Unit_instance;
    });
  }
}
function open$_anonymous_$_anonymous_$reposition$_anonymous_$bounds_vk1tys(_this__u8e3s4, sourcePosition, gap, size, screen) {
  var tmp;
  if (_this__u8e3s4.hd5_1) {
    var x = _this__u8e3s4.id5_1 ? sourcePosition.right + gap : sourcePosition.left - gap - size.width;
    var tmp_0;
    switch (_this__u8e3s4.jd5_1.b4_1) {
      case 0:
        tmp_0 = new DOMRect(x, sourcePosition.bottom - size.height, size.width, size.height);
        break;
      case 2:
        tmp_0 = new DOMRect(x, sourcePosition.top, size.width, size.height);
        break;
      case 1:
        tmp_0 = new DOMRect(x, get_centerY(sourcePosition) - size.height / 2, size.width, size.height);
        break;
      case 3:
        tmp_0 = new DOMRect(x, 0.0, size.width, screen.height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  } else {
    var y = _this__u8e3s4.id5_1 ? sourcePosition.bottom + gap : sourcePosition.top - gap - size.height;
    var tmp_1;
    switch (_this__u8e3s4.jd5_1.b4_1) {
      case 0:
        tmp_1 = new DOMRect(sourcePosition.right - size.width, y, size.width, size.height);
        break;
      case 2:
        tmp_1 = new DOMRect(sourcePosition.left, y, size.width, size.height);
        break;
      case 1:
        tmp_1 = new DOMRect(get_centerX(sourcePosition) - size.width / 2, y, size.width, size.height);
        break;
      case 3:
        tmp_1 = new DOMRect(0.0, y, screen.width, size.height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function FloatingInfoHolder$menuGenerator$lambda(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Space())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  _this__u8e3s4.fbb(p, view);
  return Unit_instance;
}
var FloatingInfoHolder$closeButton$slambdaClass;
function FloatingInfoHolder$closeButton$slambda() {
  if (FloatingInfoHolder$closeButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.pdp_1 = this$0;
      }
      sao($completion) {
        this.pdp_1.kcr();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    FloatingInfoHolder$closeButton$slambdaClass = $;
  }
  return FloatingInfoHolder$closeButton$slambdaClass;
}
function FloatingInfoHolder$closeButton$slambda_0(this$0) {
  var i = new (FloatingInfoHolder$closeButton$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var FloatingInfoHolder$block$1Class;
function FloatingInfoHolder$block$1() {
  if (FloatingInfoHolder$block$1Class === VOID) {
    class $ extends RView() {
      constructor(this$0, $o) {
        super($o.pc());
        this.tb5_1.xb3_1 = 'div';
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.tb5_1;
        var tmp0_safe_receiver = this_0.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener('click', (it) => {
            this$0.kcr();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = this_0.eb4_1['on' + 'click'];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + 'click';
          this_0.eb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            this$0.kcr();
            return Unit_instance;
          };
        }
        var tmp0 = this.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'absolute';
        tmp0.fb7_1.position = value;
        // Inline function 'com.lightningkite.kiteui.views.left' call
        this.tb5_1.bb4_1.fb7_1.left = '0';
        // Inline function 'com.lightningkite.kiteui.views.right' call
        this.tb5_1.bb4_1.fb7_1.right = '0';
        // Inline function 'com.lightningkite.kiteui.views.bottom' call
        this.tb5_1.bb4_1.fb7_1.bottom = '0';
        // Inline function 'com.lightningkite.kiteui.views.top' call
        this.tb5_1.bb4_1.fb7_1.top = '0';
        // Inline function 'com.lightningkite.kiteui.views.opacity' call
        this.tb5_1.bb4_1.fb7_1.opacity = '0';
        // Inline function 'com.lightningkite.kiteui.views.zIndex' call
        this.tb5_1.bb4_1.fb7_1.zIndex = '998';
        this.tb5_1.hb4_1.v('active-' + Default_getInstance().ul());
        this$0.hc2_1 = this;
      }
    }
    initMetadataForClass($);
    FloatingInfoHolder$block$1Class = $;
  }
  return FloatingInfoHolder$block$1Class;
}
function FloatingInfoHolder$open$lambda() {
  return Unit_instance;
}
var FloatingInfoHolderClass;
function FloatingInfoHolder() {
  if (FloatingInfoHolderClass === VOID) {
    class $ {
      constructor(source) {
        this.fc2_1 = source;
        this.gc2_1 = 32;
        this.hc2_1 = null;
        this.ic2_1 = null;
        this.jc2_1 = null;
        this.kc2_1 = Companion_getInstance().zcq_1;
        this.lc2_1 = this.kc2_1;
        var tmp = this;
        tmp.mc2_1 = FloatingInfoHolder$menuGenerator$lambda;
      }
      odp() {
        if (!(this.ic2_1 == null))
          return Unit_instance;
        var tmp0_elvis_lhs = get_overlayFrame(this.fc2_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var o = tmp;
        var tmp1_elvis_lhs = this.jc2_1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var v = tmp_0;
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = o.bbb_1;
        var tmp_1 = o;
        tmp_1.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          this.ic2_1 = _this__u8e3s4;
          return Unit_instance;
        };
        var tmp$ret$1 = Companion_getInstance_1();
        var tmp_2 = o.ibb(tmp$ret$1, get_atTopEnd(o));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Button())(o.pc());
        var tmp0_elvis_lhs_0 = o.cbb_1;
        var p = tmp0_elvis_lhs_0 == null ? o : tmp0_elvis_lhs_0;
        o.ebb(p, view);
        icon(view, Companion_getInstance_0().tcf_1, 'Close');
        onClick(view, VOID, VOID, FloatingInfoHolder$closeButton$slambda_0(this));
        o.fbb(p, view);
        o.jbb(tmp_2, view);
      }
      dc4() {
        if (!(this.hc2_1 == null))
          return Unit_instance;
        var tmp0_elvis_lhs = get_overlayFrame(this.fc2_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var o = tmp;
        var tmp1_elvis_lhs = this.jc2_1;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var v = tmp_0;
        var tmp_1 = o.oba().s1(v);
        o.qba(tmp_1, new (FloatingInfoHolder$block$1())(this, o));
      }
      cc4() {
        if (!(this.jc2_1 == null))
          return Unit_instance;
        var removeElementFromOverlay = {_v: FloatingInfoHolder$open$lambda};
        var tmp = ensureNotNull(get_overlayFrame(this.fc2_1));
        var popoverWriter_0 = popoverWriter(this.fc2_1, tmp, VOID, () => {
          removeElementFromOverlay._v();
          return Unit_instance;
        });
        // Inline function 'kotlin.with' call
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(popoverWriter_0.pc());
        var tmp0_elvis_lhs = popoverWriter_0.cbb_1;
        var p = tmp0_elvis_lhs == null ? popoverWriter_0 : tmp0_elvis_lhs;
        popoverWriter_0.ebb(p, view);
        var $this$frame = view;
        keepPopoverOpen(this.fc2_1, $this$frame);
        this.lc2_1 = this.kc2_1;
        this.jc2_1 = $this$frame;
        $this$frame.jba(PopoverSemantic_getInstance());
        var tmp0 = $this$frame.tb5_1.bb4_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'absolute';
        tmp0.fb7_1.position = value;
        // Inline function 'com.lightningkite.kiteui.views.zIndex' call
        $this$frame.tb5_1.bb4_1.fb7_1.zIndex = '999';
        // Inline function 'com.lightningkite.kiteui.views.height' call
        $this$frame.tb5_1.bb4_1.fb7_1.height = 'auto';
        // Inline function 'com.lightningkite.kiteui.views.width' call
        $this$frame.tb5_1.bb4_1.fb7_1.width = 'unset';
        // Inline function 'com.lightningkite.kiteui.views.height' call
        $this$frame.tb5_1.bb4_1.fb7_1.height = 'unset';
        $this$frame.tb5_1.hb4_1.v('popover');
        var tx = {_v: 0.0};
        var txm = {_v: 0};
        var ty = {_v: 0.0};
        var tym = {_v: 0};
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_0 = $this$frame.tb5_1;
        var tmp0_safe_receiver = this_0.vb3_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          if (!(tmp0_safe_receiver instanceof HTMLElement))
            THROW_CCE();
          (new ResizeObserver((entry, observer) => {
            open$_anonymous_$_anonymous_$reposition_r379wc($this$frame, this, tx, ty, txm, tym);
            return Unit_instance;
          })).observe(tmp0_safe_receiver);
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this_0.ub3_1.v((it) => {
            if (!(it instanceof HTMLElement))
              THROW_CCE();
            (new ResizeObserver((entry, observer) => {
              open$_anonymous_$_anonymous_$reposition_r379wc($this$frame, this, tx, ty, txm, tym);
              return Unit_instance;
            })).observe(it);
            return Unit_instance;
          });
        }
        this.mc2_1($this$frame);
        $this$frame.tb5_1.xdo();
        open$_anonymous_$_anonymous_$reposition_r379wc($this$frame, this, tx, ty, txm, tym);
        var repos = (ev) => {
          open$_anonymous_$_anonymous_$reposition_r379wc($this$frame, this, tx, ty, txm, tym);
          return Unit_instance;
        };
        window.addEventListener('scroll', repos, true);
        var mouseMove = (it) => {
          if (!(it instanceof MouseEvent))
            THROW_CCE();
          var tmp;
          if (this.hc2_1 == null && get_popoverKeepOpen($this$frame) <= 0) {
            var tmp_0 = this.fc2_1.tb5_1.vb3_1;
            var clientRect = (tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE()).getBoundingClientRect();
            var tmp_1 = $this$frame.tb5_1.vb3_1;
            var popUpRect = (tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE()).getBoundingClientRect();
            var tmp_2;
            var tmp0 = maxOf(it.x - popUpRect.right, new Float64Array([popUpRect.left - it.x, it.y - popUpRect.bottom, popUpRect.top - it.y]));
            // Inline function 'kotlin.math.min' call
            var b = maxOf(it.x - clientRect.right, new Float64Array([clientRect.left - it.x, it.y - clientRect.bottom, clientRect.top - it.y]));
            if (Math.min(tmp0, b) > this.gc2_1) {
              this.kcr();
              tmp_2 = Unit_instance;
            }
            tmp = tmp_2;
          }
          return Unit_instance;
        };
        window.addEventListener('mousemove', mouseMove);
        removeElementFromOverlay._v = () => {
          var tmp0_safe_receiver = this.hc2_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            ensureNotNull(get_overlayFrame(this.fc2_1)).sba(tmp0_safe_receiver);
          }
          this.hc2_1 = null;
          var tmp1_safe_receiver = this.ic2_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            ensureNotNull(get_overlayFrame(this.fc2_1)).sba(tmp1_safe_receiver);
          }
          this.ic2_1 = null;
          window.removeEventListener('scroll', repos, true);
          window.removeEventListener('mousemove', mouseMove);
          // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
          var this_0 = $this$frame.tb5_1;
          var tmp0_safe_receiver_0 = this_0.vb3_1;
          var tmp;
          if (tmp0_safe_receiver_0 == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            $this$frame.la9();
            if (!(tmp0_safe_receiver_0 instanceof HTMLElement))
              THROW_CCE();
            // Inline function 'kotlin.let' call
            var it = window.getComputedStyle(tmp0_safe_receiver_0).getPropertyValue('transition-duration');
            var tmp0_elvis_lhs = Companion_getInstance_2().yu(it);
            var tmp_0;
            var tmp_1 = tmp0_elvis_lhs;
            if ((tmp_1 == null ? null : new (Duration())(tmp_1)) == null) {
              // Inline function 'kotlin.time.Companion.seconds' call
              Companion_getInstance_2();
              tmp_0 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            // Inline function 'kotlin.let' call
            var it_0 = tmp_0;
            var tmp_2 = window;
            tmp_2.setTimeout(() => {
              ensureNotNull(get_overlayFrame(this.fc2_1)).sba($this$frame);
              return Unit_instance;
            }, convertToInt(_Duration___get_inWholeMilliseconds__impl__msfiry(it_0)));
            tmp0_safe_receiver_0.style.opacity = '0';
            tmp0_safe_receiver_0.style.setProperty('pointer-events', 'none');
            tmp = Unit_instance;
          }
          if (tmp == null) {
            this_0.ub3_1.v((it) => {
              $this$frame.la9();
              if (!(it instanceof HTMLElement))
                THROW_CCE();
              // Inline function 'kotlin.let' call
              var it_0 = window.getComputedStyle(it).getPropertyValue('transition-duration');
              var tmp0_elvis_lhs = Companion_getInstance_2().yu(it_0);
              var tmp;
              var tmp_0 = tmp0_elvis_lhs;
              if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
                // Inline function 'kotlin.time.Companion.seconds' call
                Companion_getInstance_2();
                tmp = toDuration(0.25, DurationUnit_SECONDS_getInstance());
              } else {
                tmp = tmp0_elvis_lhs;
              }
              // Inline function 'kotlin.let' call
              var it_1 = tmp;
              var tmp_1 = window;
              tmp_1.setTimeout(() => {
                ensureNotNull(get_overlayFrame(this.fc2_1)).sba($this$frame);
                return Unit_instance;
              }, convertToInt(_Duration___get_inWholeMilliseconds__impl__msfiry(it_1)));
              it.style.opacity = '0';
              it.style.setProperty('pointer-events', 'none');
              return Unit_instance;
            });
          }
          this.jc2_1 = null;
          return Unit_instance;
        };
        popoverWriter_0.fbb(p, view);
      }
      kcr() {
        closeSiblingPopovers(this.fc2_1);
      }
    }
    initMetadataForClass($, 'FloatingInfoHolder');
    FloatingInfoHolderClass = $;
  }
  return FloatingInfoHolderClass;
}
function get_centerY(_this__u8e3s4) {
  return (_this__u8e3s4.top + _this__u8e3s4.bottom) / 2;
}
function get_centerX(_this__u8e3s4) {
  return (_this__u8e3s4.left + _this__u8e3s4.right) / 2;
}
//region block: exports
export {
  FloatingInfoHolder as FloatingInfoHolder1eisb99cxddo9,
};
//endregion

//# sourceMappingURL=FloatingInfoHolder.js.mjs.map
